import { initLanguageSetting } from '@/locales/languageSettingMethod';
initLanguageSetting();
